export default (function () {
  const WEEK_DURATION = 1000 * 60 * 60 * 24 * 7;
  function save(name = '', data = {}, expiration = WEEK_DURATION) {
    const timestamp = new Date().getTime();
    let storageData = {
      timestamp: timestamp,
      expiration: expiration,
      data: data,
    };
    //localStorage.setItem(name, btoa(JSON.stringify(storageData)));
    localStorage.setItem(name, JSON.stringify(storageData));
  }

  function read(name = '') {
    let storageData = JSON.parse(localStorage.getItem(name));
    if (!storageData) {
      return null;
    }
    const timestamp = new Date().getTime();
    if (storageData.timestamp + storageData.expiration < timestamp) {
      localStorage.removeItem(name);
      return null;
    }
    return JSON.parse(storageData.data);
  }

  return {
    save: save,
    read: read,
  };
})();
